import React from "react";
//import classNames from "../utils/class-names";
//import useInterval from "../utils/useInterval";
import SetDuration from "./SetDuration";
//import Progress from "./Progress";


function Pomodoro() {
  document.title="Behrooz Timer";
  
  return (
      <SetDuration />
  );
}

export default Pomodoro;
